import React from 'react'
import { Button, Image } from 'react-bootstrap'
/*  TODO
            <div id="vin-box" className="pull-left" style={ { width:"295px", height:"130px" } }>
              <div style={{  display: "inline-block", padding: "8px", border: "1px solid #000", borderRadius: "5px", lineHeight: "20px", background: "linear-gradient(to bottom, rgba(237,237,237,1) 0%,rgba(255,255,255,1) 100%)" } }>

                <div style={{  font: "bold 15px arial" } }>Check Your VIN Instantly:</div>
                <form action="http://www.vinaudit.com/go.php" method="POST" style={{  margin: "8px 0 5px", textAlign: "center" } }>
                  <input name="r" readOnly value="YnVzaW5lc3Muc3VwcG9ydEBjYXJmaW5kZXIuY29t" type="hidden"/>
                  <input name="vin" readOnly value={ item.vin } style={{  width: "150px" } } type="text"/>
                  <input value="Check VIN" type="submit"/>
                </form>
                <div style={{  textAlign: "center", font: "12px arial" } }>
                  Powered by <img alt="logo" src="http://www.vinaudit.com/links/text-18.gif"/>
                </div>
              </div>
            </div>
            */

export default class VinAuditButton extends React.Component {
  handleVinAuditClick = event => {
    const r = 'YnVzaW5lc3Muc3VwcG9ydEBjYXJmaW5kZXIuY29t'
    const url = 'https://www.vinaudit.com/go.php'
    window.location.href = `${url}?r=${r}&vin=${this.props.vin}`
  }

  render() {
    return (
      <Button
        title="Check your VIN instantly"
        onClick={this.handleVinAuditClick}
        className="vinaudit-button"
        data-vin={this.props.vin}
      >
        <Image
          responsive
          alt="logo"
          src="https://www.vinaudit.com/links/text-18.gif"
        />{' '}
        {this.props.vin}
      </Button>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/DataView/VinAuditButton.js